import * as React from 'react';
import { Create, useNotify, useAuthState, Loading } from 'react-admin';
import { JobForm } from '../jobs/commons';
import { preventSubmitOnSubmit } from './utils';

const JobPublicCreate = () => {
    const notify = useNotify();
    const { isLoading, authenticated } = useAuthState();
    if (isLoading) {
        return <Loading />;
    }
    return (
        <Create disableAuthentication>
            <JobForm onSubmit={preventSubmitOnSubmit(authenticated, notify)} />
        </Create >
    )
}

export default JobPublicCreate;